<header class="header" [class.header--light]="!isHome">

    <div class="header__container container-redesign">

        <a class="header__logo" routerLink="/home-redesign">
            <img
    [src]="
        isHome
            ? 'assets/img/white-logo.png'
            : 'assets/img/dark-logo.png'
    "
    alt="Althea Soft Ltd">
        </a>

        <nav
    class="header__nav"
    [class.header__nav--active]="isMenuOpen">

            <ul class="header__menu">

                <li
                    class="header__item"
                    *ngFor="let item of menuItems">

                    <a
                        class="header__link"
                        [routerLink]="item.route">

                        {{ item.label }}

                    </a>

                </li>

            </ul>

        </nav>

        <div class="header__actions">

            <a href="/contact-redesign" class="header__button">

                CONTACT US

                <img
        src="/assets/img/redesign/flecha.svg"
        alt=""
        class="hero__button-icon">

            </a>

        </div>
        <button
    class="header__toggle"
    [class.header__toggle--active]="isMenuOpen"
    (click)="toggleMenu()">

            <span class="header__toggle-line"></span>
            <span class="header__toggle-line"></span>
            <span class="header__toggle-line"></span>
        </button>

    </div>

</header>